module.exports = __webpack_public_path__ + "img/right_from_bracket_blue.e7272200.svg";